import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
import { useSelector } from 'react-redux';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import AllNews from 'app/components/district/news/AllNews';
import { useRestoreData } from 'app/hooks/dataHooks';
import DistrictNewsResponse from 'app/components/topNewsModule/models/DistrictNewsResponse';
import LoadCurrentDataButton from 'app/components/district/news/LoadCurrentDataButton';
import queryString from 'query-string';
import { useLocation, useParams } from 'react-router';
import { ErrorHandler } from 'app/components/error/ErrorHandler';
import { useAppBarTitle } from 'app/hooks/appBar/useAppBarTitle';
import { useDistrictChangeAppBarParent } from 'app/hooks/appBar/useDistrictChangeAppBarParent';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1tc57eq-0"
})(["margin-top:calc(", " + env(safe-area-inset-top));display:flex;flex-direction:column;align-items:center;"], SIZES['80']);
export default function DistrictAllNewsPage() {
  const {
    name
  } = useSelector(reduxSelectDistrict);
  const {
    districtSlug
  } = useParams();
  const location = useLocation();
  const searchQuery = queryString.parse(location.search);

  // refactor with task https://fupa.atlassian.net/browse/DV-17149
  useAppBarTitle('Alle Meldungen');
  useDistrictChangeAppBarParent();
  const {
    restoredData
  } = useRestoreData('DistrictAllNewsPage');
  const initialState = restoredData ? new DistrictNewsResponse(restoredData) : undefined;
  const title = "Alle Meldungen - ".concat(name, " - FuPa");
  const meta = [{
    name: 'description',
    content: "Fu\xDFballkreis ".concat(name, " - Alle Nachrichten und Meldungen zum Amateurfu\xDFball aus deiner Region ").concat(name, ".")
  }, {
    name: 'robots',
    content: 'index, follow'
  }];
  const canonical = searchQuery !== null && searchQuery !== void 0 && searchQuery.page ? /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: location.pathname
  }) : null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "DistrictAllNewsPage",
    "data-sentry-source-file": "DistrictAllNewsPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    meta: meta,
    title: title,
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "DistrictAllNewsPage.tsx"
  }, canonical), /*#__PURE__*/React.createElement(ErrorHandler, {
    subroute: false,
    "data-sentry-element": "ErrorHandler",
    "data-sentry-source-file": "DistrictAllNewsPage.tsx"
  }, /*#__PURE__*/React.createElement(AllNews, {
    slug: districtSlug,
    initialData: initialState,
    "data-sentry-element": "AllNews",
    "data-sentry-source-file": "DistrictAllNewsPage.tsx"
  }), /*#__PURE__*/React.createElement(LoadCurrentDataButton, {
    "data-sentry-element": "LoadCurrentDataButton",
    "data-sentry-source-file": "DistrictAllNewsPage.tsx"
  })));
}